export const audits = {
	navTitle: " Audit",
};
